var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticStyle:{"height":"100%","display":"flex","align-items":"center","justify-content":"center"}},[_vm._v("页面没有找到！")])}
var staticRenderFns = []

export { render, staticRenderFns }